import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { SearchResult } from '../data/search-result';
import { FormControlConfig } from '../decorator/form-control-config';
import { environment } from '../environments/environment';

export const API_KEY_RESTRICTIONS = ['none', 'HTTP', 'IP'] as const;
export type ApiKeyRestriction = typeof API_KEY_RESTRICTIONS[number];

export class ApiKey {

    @FormControlConfig({})
    apiKey: string;

    @FormControlConfig({ validators: [Validators.required, Validators.maxLength(40)] })
    name: string;

    monthlyExecuted?: number;
    daylyExecuted?: number;
    lastCountDate?: Date;

    @FormControlConfig({ validators: [Validators.required] })
    restriction: ApiKeyRestriction = 'none';

    @FormControlConfig({})
    restrictionText: string;

    @FormControlConfig({ array: true })
    restrictions: string[];

    lastSendKongDate?: Date;
    created?: Date;

    constructor(init?: Partial<ApiKey>) {
        Object.assign(this, init);
    }

}

export class ApiKeyForCreate extends ApiKey {
}


@Injectable({
    providedIn: 'root'
})
export class ApiKeyService {

    constructor(private http: HttpClient) { }

    list(queryParams: HttpParams): Observable<SearchResult<ApiKey>> {
        return this.http.get<SearchResult<ApiKey>>(environment.apiUrl + '/v1/apikeys', { params: queryParams });
    }

    get(id: string): Observable<ApiKey> {
        return this.http.get<ApiKey>(environment.apiUrl + '/v1/apikeys/' + id);
    }

    create(data: ApiKeyForCreate): Observable<ApiKey> {
        return this.http.post<ApiKey>(environment.apiUrl + '/v1/apikeys', data);
    }

    update(id: string, data: ApiKey): Observable<ApiKey> {
        return this.http.put<ApiKey>(environment.apiUrl + '/v1/apikeys/' + id, data);
    }

    delete(id: string): Observable<any> {
        return this.http.delete(environment.apiUrl + '/v1/apikeys/' + id);
    }


}
